// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Channel transport protocol.
 */
export enum ChannelType {
  SERIAL = 0,
  TCP = 1,
  UDP = 2,
  ADAPTER = 3,
  TCP_BOT = 4,
  HTTP = 5,
}
